<!--
 * @Version: 1.0.0
 * @Description: file content
 * @Autor: zhiqiang.xia@dsicm.com
 * @Date: 2021-05-17 15:45:18
 * @LastEditors: enbo.zhou@dsicm.com
 * @LastEditTime: 2021-07-15 17:13:35
 * @FilePath: /dsicm-admin-web/src/views/StandardDatabase/src/case-3/index.vue
-->
<template>
    <el-container class="test-page">
        <div class="headerCom">
            <publicBreadCrumb :breadList="breadList" />
            <publicExpandSearch padBottom='0px' :searchList='searchList' :rightEventList="rightEventList"
                @rightFunc='rightFunc' v-on:getSearchObj='getSearchObj'>
            </publicExpandSearch>
        </div>
        <!-- 中间列表数据 -->
        <el-main class="table-coiner">
            <div class="table-cotainer">
                <h1>检查项目列表</h1>
                <BaseTable :data="tableData" :column="drugTableListConfig" pagination :auto-scroll="true"
                    :total="totalPage" :page.sync="searchParams.current" :limit.sync="searchParams.size"
                    @pagination="getList">
                </BaseTable>
            </div>
        </el-main>
        <addModule ref="addModuleRef" @upadate="initList" @upDatas="upDataItem" :formDataValue="scopeItem"></addModule>
    </el-container>
</template>

<script>

import mixinsTable from './mixins.table.config';
import addModule from './components/index.vue';
import { apiExamineInfoList, apiDeleteStatus, apiPutUpdateStatus } from './api'
export default {
    components: {
        addModule
    },
    mixins: [mixinsTable],
    data() {
        return {
            breadList: [{ name: "标准数据库" }, { name: "检查" }],
            searchList: [
                {
                    label: "检查类别或者检查项目名称",
                    paramName: "condition",
                    inputType: "input",
                    width: '280px'
                }
            ],
            searchParams: {
                current: 1,
                size: 10
            },
            rightEventList: [{ eventName: "新增检查项目", eventValue: 1 }],
            // listQuery: {
            //     condition:"",//输入框搜索字段
            //     current:1,//页数
            //     size:10,//每页多少条
            // },
            tableData: [],
            totalPage: 0,//总数
            scopeItem: {},
        }
    },
    mounted() {
        this.init()
    },
    methods: {
        getSearchObj(obj) {
            this.searchParams = this.$options.data().searchParams;
            this.searchParams = { ...obj, ...this.searchParams };
            this.getList()
        },
        rightFunc(item) {
            if (item.eventValue == 1) {
                this.$refs.addModuleRef.openDialog()
            }
        },
        /**
 * @description: 关闭弹窗通知清除数据，否则watch监听不到
 * @param {*}
 * @return {*}
 */
        upDataItem() {
            this.scopeItem = {}
        },
        /**
         * @description: 编辑
         * @param {*}
         * @return {*}
         */
        editHandel(scope) {
            this.scopeItem = scope;
            this.$refs.addModuleRef.editProject()
        },
        /**
         * @description: 停用或者启用
         * @param {*}
         * @return {*}
         */
        blockUp(scope) {
            apiPutUpdateStatus(scope.id).then(res => {
                if (res.code == 0) {
                    this.$message.success('修改成功');
                    this.init()
                }
            })
        },
        /**
         * @description: 删除
         * @param {*}
         * @return {*}
         */
        removeHandel(scope) {
            this.$confirm('确定要删除当前检查项目的全部信息吗?', '提示', {
                confirmButtonClass: 'classBtn',
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'primary',
                customClass: 'message-confirm-style'
            }).then(() => {
                apiDeleteStatus(scope.row.id).then(res => {
                    if (res.code == 0) {
                        this.$message.success('删除成功');
                        this.init();
                    }
                })
            })
        },

        /**
         * @description: 
         * @param {*}
         * @return {*}
         */
        initList() {
            this.init()
        },
        /**
         * @description: 初始化
         * @param {*}
         * @return {*}
         */
        init() {
            apiExamineInfoList(this.searchParams).then(res => {
                if (res.code == 0) {
                    this.tableData = res.data.records;
                    this.totalPage = res.data.total
                }
            })
        },
        /**
         * @description: 分页
         * @param {*}
         * @return {*}
         */
        getList() {
            this.init()
        },
    }
}
</script>

<style lang="less" scoped>
.test-page {
    height: 100%;
    display: flex;
    flex-direction: column;
}

.table-coiner {

    .table-cotainer {
        margin: 0 17px;

        h1 {
            line-height: 60px;
            font-size: 14px;
            color: #333333;
        }
    }

    margin: 0 10px;
    padding: 0;
    background: #fff;
    border-radius: 6px;
}

.classBtn {
    background: red !important;
}
</style>
